<template>
  <div class="assistant-card quote-card">
    <div class="quote-card__header">
      <strong>
        Cotización {{ quote.reference }}
        <span v-if="quote.name" class="quote-card__name"
          >· {{ quote.name }}</span
        >
      </strong>
      <button type="button" @click="$emit('open', quote.orderNumber)">
        <i class="mdi mdi-open-in-new"></i> Abrir
      </button>
    </div>
    <p class="quote-card__meta">
      {{ quote.customerName || "Sin cliente" }} · precio {{ quote.priceLevel }}
    </p>

    <!-- Lo que le falta para estar completa (quoteLines.js) -->
    <p v-if="missing.length" class="quote-card__missing">
      <i class="mdi mdi-alert-outline"></i> Falta: {{ missing.join(", ") }}
    </p>
    <p v-else-if="quote.missing" class="quote-card__complete">
      <i class="mdi mdi-check-circle-outline"></i> Completa
    </p>

    <ul>
      <li v-for="item in quote.added" :key="item.nkrCode">
        <span>{{ item.quantity }} × <NkrCodeLink :code="item.nkrCode"/></span>
        <span>{{ money(item.price * item.quantity) }}</span>
      </li>
    </ul>

    <!-- Las conversaciones guardadas antes no traen totales del sistema -->
    <dl v-if="quote.totals" class="quote-card__totals">
      <dt>Piezas</dt>
      <dd>{{ money(quote.totals.products) }}</dd>
      <template v-if="quote.totals.discount">
        <dt>Descuento</dt>
        <dd>−{{ money(quote.totals.discount) }}</dd>
      </template>
      <dt>Envío</dt>
      <dd>{{ quote.shipping ? money(quote.totals.shipping) : "—" }}</dd>
      <dt>Impuesto</dt>
      <dd>{{ money(quote.totals.tax) }}</dd>
      <dt class="is-total">Total</dt>
      <dd class="is-total">{{ money(quote.totals.total) }}</dd>
    </dl>
    <p v-else class="quote-card__total">Total {{ money(linesTotal) }}</p>

    <dl v-if="quote.totals" class="quote-card__details">
      <dt>Envío</dt>
      <dd>{{ quote.shipping ? quote.shipping.service : "—" }}</dd>
      <dt>Dirección</dt>
      <dd>{{ quote.shippingAddress || "—" }}</dd>
      <dt>Pago</dt>
      <dd>
        {{ quote.paymentType || "—" }}
        <template v-if="quote.paymentTerms">
          · {{ quote.paymentTerms }}</template
        >
      </dd>
      <template v-if="quote.purchaseOrder">
        <dt>PO</dt>
        <dd>{{ quote.purchaseOrder }}</dd>
      </template>
      <template v-if="quote.vin">
        <dt>VIN</dt>
        <dd>{{ quote.vin }}</dd>
      </template>
      <template v-if="quote.customerNotes">
        <dt>Notas</dt>
        <dd>{{ quote.customerNotes }}</dd>
      </template>
      <template v-if="quote.internalNotes">
        <dt>Internas</dt>
        <dd>{{ quote.internalNotes }}</dd>
      </template>
    </dl>

    <ul v-if="quote.skipped.length" class="quote-card__skipped">
      <li v-for="item in quote.skipped" :key="item.nkrCode">
        <NkrCodeLink :code="item.nkrCode" />: {{ item.reason }}
      </li>
    </ul>
    <ul v-if="quote.warnings.length" class="quote-card__skipped">
      <li v-for="warning in quote.warnings" :key="warning">{{ warning }}</li>
    </ul>
  </div>
</template>

<script>
import { money } from "../format.js";
import NkrCodeLink from "./NkrCodeLink.vue";

// Resultado de create_quote, update_quote y quote_shipping: la cotización
// como quedó guardada y lo que le falta
export default {
  name: "QuoteCard",
  components: { NkrCodeLink },
  props: {
    quote: { type: Object, required: true }
  },
  computed: {
    missing() {
      return this.quote.missing || [];
    },
    linesTotal() {
      return this.quote.added.reduce(
        (sum, item) => sum + item.price * item.quantity,
        0
      );
    }
  },
  methods: { money }
};
</script>

<style lang="scss" scoped>
@import "./card.scss";

.quote-card__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  button {
    font-size: 12px;
    color: #2563eb;
  }
}
.quote-card__name {
  font-weight: 400;
  color: #6b7280;
}
.quote-card__meta {
  font-size: 11px;
  color: #6b7280;
  margin-bottom: 6px;
}
.quote-card__missing {
  margin-bottom: 6px;
  padding: 4px 8px;
  border-radius: 6px;
  background: #fffbeb;
  color: #b45309;
  font-size: 12px;
}
.quote-card__complete {
  margin-bottom: 6px;
  color: #15803d;
  font-size: 12px;
}
li {
  display: flex;
  justify-content: space-between;
  font-size: 12px;
}
.quote-card__total {
  margin-top: 4px;
  text-align: right;
  font-weight: 600;
}
.quote-card__totals,
.quote-card__details {
  display: grid;
  grid-template-columns: auto 1fr;
  gap: 2px 12px;
  margin-top: 6px;
  padding-top: 6px;
  border-top: 1px solid #eef0f3;
  font-size: 12px;
  dt {
    color: #6b7280;
  }
}
.quote-card__totals dd {
  text-align: right;
}
.quote-card__details dd {
  min-width: 0;
  overflow-wrap: anywhere;
}
.is-total {
  font-weight: 600;
  color: #111827 !important;
}
.quote-card__skipped {
  margin-top: 6px;
  li {
    color: #b45309;
  }
}
</style>
